import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  loader: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    flexShrink: 0,
    color: theme.palette.labraText.tertiary,
  },
  check: {
    color: theme.palette.syncStatus.success,
  },
  normal: {
    color: theme.palette.labraIcon.main,
  },
  cross: {
    color: theme.palette.error.dark,
  },
}))
